import React from 'react';

export const Logo = ({ className = "", variant = "default" }) => {
  // variant: "default" (dark text), "light" (white text for dark backgrounds)
  const textColor = variant === "light" ? "fill-white" : "fill-slate-900";
  
  return (
    <svg 
      viewBox="0 0 240 40" 
      className={`h-10 w-auto ${className}`}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      aria-label="WorkRidePro Logo"
    >
      {/* Icon: Stylized Abstract 'W' / Road / Motion */}
      <path 
        d="M10 12L16 32L22 16L28 32L34 12" 
        stroke="url(#logo-gradient)" 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      
      {/* Text: WorkRidePro */}
      <text
        x="45"
        y="28"
        fontFamily="'Inter', sans-serif"
        fontWeight="700"
        fontSize="28"
        fill="hsl(172, 66%, 45%)"
        style={{ letterSpacing: '-0.5px' }}
      >
        WorkRide<tspan fill="#10B981">Pro</tspan>
      </text>

      <defs>
        <linearGradient id="logo-gradient" x1="10" y1="12" x2="34" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF9900" />
          <stop offset="1" stopColor="#FF5500" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
